import React, { useState } from "react";
import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import { FaGlobe } from "react-icons/fa";
import Pager from "components/ui/controls/pager/pager";
import Column from "components/ui/layout/column/column";
import CardBox from "components/ui/controls/card-box/card-box";
import Row from "components/ui/layout/row/row";
import Modal from "components/ui/modal/modal";
import DropDown from "components/ui/controls/drop-down/drop-down";

const PointCarpimkoAsv = (props) => {
  const { resultRetraite, ClientConjoint } = props;
  const context = useContext(AppContext);

  let [openModal, setOpenModal] = useState(false);
  const InitialAnneeAcquisition = () => {
    const dt = new Date();

    return dt.getFullYear() - 2;
  };
  return (
    <>
      {context.state["Carriere" + ClientConjoint].filter((Carriere) => Carriere.Nature === "Carpimko" && Carriere.ParamCotisations.Conventionne === "oui").length > 0 && (
        <tr>
          <td>ASV CARPIMKO</td>
          <td
            onClick={() => {
              setOpenModal(true);
            }}
          >
            <TextField
              value={context.state["TableauPoints" + ClientConjoint].RetraiteSuppCarpimko}
              style={{ backgroundColor: "white" }}
              disabled
              dataType="ufloat"
              format={{ thousands: " ", precision: 2, decimal: "," }}
              small
            />
          </td>
          <td>
            <DropDown
              value={context.state["TableauPoints" + ClientConjoint].AnneeFinCarpimkoSupp}
              onChange={(e) => {
                context.handlePointRetraite(ClientConjoint, "AnneeFinCarpimkoSupp", e);
                props.CalculRetraite();
              }}
              options={[
                { value: InitialAnneeAcquisition(), label: InitialAnneeAcquisition() },
                { value: InitialAnneeAcquisition() + 1, label: InitialAnneeAcquisition() + 1 },
              ]}
              small
            />
          </td>
          <td>
            <TextField
              value={resultRetraite?.InfosRetraite?.Carpimko?.General?.AsvPointCalcule === undefined ? 0 : resultRetraite?.InfosRetraite?.Carpimko?.General?.AsvPointCalcule}
              disabled={true}
              dataType="ufloat"
              format={{ thousands: " ", precision: 2, decimal: "," }}
              small
            />
          </td>
        </tr>
      )}

      <Modal
        width="30%"
        height="30%"
        title="POINTS ASV CARPIMKO"
        icon={<FaGlobe />}
        visible={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
      >
        <Pager
          pages={[
            {
              content: (
                <Column fill>
                  <CardBox>
                    <Column fill>
                      <Row>
                        <Column>
                          <TextField
                            label="Entre 1960 et 1975"
                            value={context.state["TableauPoints" + ClientConjoint].RetraiteSuppCarpimko19601975}
                            onChange={context.handleModalPoint(ClientConjoint, "RetraiteSuppCarpimko19601975")}
                            dataType="ufloat"
                            format={{ thousands: " ", precision: 2, decimal: "," }}
                            normal
                          />
                        </Column>
                      </Row>
                      <Row>
                        <Column>
                          <TextField
                            label="Entre 1976 et 1987"
                            value={context.state["TableauPoints" + ClientConjoint].RetraiteSuppCarpimko19761987}
                            onChange={context.handleModalPoint(ClientConjoint, "RetraiteSuppCarpimko19761987")}
                            dataType="ufloat"
                            format={{ thousands: " ", precision: 2, decimal: "," }}
                            normal
                          />
                        </Column>
                      </Row>
                      <Row>
                        <Column>
                          <TextField
                            label="Entre 1988 et 1997"
                            value={context.state["TableauPoints" + ClientConjoint].RetraiteSuppCarpimko19881997}
                            onChange={context.handleModalPoint(ClientConjoint, "RetraiteSuppCarpimko19881997")}
                            dataType="ufloat"
                            format={{ thousands: " ", precision: 2, decimal: "," }}
                            normal
                          />
                        </Column>
                      </Row>
                      <Row>
                        <Column>
                          <TextField
                            label="Entre 1998 et 2005"
                            value={context.state["TableauPoints" + ClientConjoint].RetraiteSuppCarpimko19982005}
                            onChange={context.handleModalPoint(ClientConjoint, "RetraiteSuppCarpimko19982005")}
                            dataType="ufloat"
                            format={{ thousands: " ", precision: 2, decimal: "," }}
                            normal
                          />
                        </Column>
                      </Row>
                      <Row>
                        <Column>
                          <TextField
                            label={"Entre 2006 et " + context.state.TableauPoints.AnneeFinCarpimkoSupp}
                            value={context.state["TableauPoints" + ClientConjoint].RetraiteSuppCarpimkoApres2005}
                            onChange={context.handleModalPoint(ClientConjoint, "RetraiteSuppCarpimkoApres2005")}
                            dataType="ufloat"
                            format={{ thousands: " ", precision: 2, decimal: "," }}
                            normal
                          />
                        </Column>
                      </Row>
                    </Column>
                  </CardBox>
                </Column>
              ),
            },
          ]}
          page={0}
          navButtons={{
            validate: {
              onClick: (evt) => {
                setOpenModal(false);
              },
            },
          }}
        />
      </Modal>
    </>
  );
};
export default PointCarpimkoAsv;
